import { t } from './i18n.js';

$(document).ready(function() {

    // Handle the "Save" button click inside the modal
    $('#saveEstablishedDateBtn').on('click', function() {
        
        function getCookie(name) {
            let cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let cookie of cookies) {
                    cookie = cookie.trim();
                    if (cookie.startsWith(name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        }
        const csrftoken = getCookie('csrftoken');
        
        let selectedDate = $('.datepicker').val();
        let ensembleSlug = $('.established-date-edit').data('ensemble-slug');
        let apiUrl = $('.established-date-edit').data('update-url');
        
        $.ajax({
            url: apiUrl,
            headers: { "X-CSRFToken": csrftoken },
            type: 'POST',
            data: {
                'date': selectedDate,
                'ensemble_slug': ensembleSlug,
            },
            success: function(response) {
                console.log('Success:', response);
                $('#editEstablishedDateModal').modal('hide');
                
                // Update the displayed date
                if (response.established_date) {
                    $('.ensemble-established-date').text(response.established_date);
                } else {
                    $('.ensemble-established-date').text(t('notSet'));
                }
            },
            error: function(xhr, status, error) {
                console.error('Error status:', xhr.status); 
                
                let errorMessage = t('serverError');
                
                try {
                    const responseData = JSON.parse(xhr.responseText);
                
                    if (responseData.message) {
                        errorMessage = responseData.message;
                    }
                } catch (e) {
                    console.error('JSON parse error:', e);
                }
                
                alert(t('errorLabel') + errorMessage);
            }
        });
    });

    // Save main voices (repeater identical to add_song)
    $('#saveMainVoicesBtn').on('click', function() {
        function getCookie(name) {
            let cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let cookie of cookies) {
                    cookie = cookie.trim();
                    if (cookie.startsWith(name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        }
        const csrftoken = getCookie('csrftoken');

        // Update order numbers before serialization
        $('#song-voices .song-voice-item').not('.template').each(function(i, item){
            $(item).find('.song-voice-item-order-input').val(i + 1);
        });

        let ensembleSlug = $('.main-voices-edit').data('ensemble-slug');
        let apiUrl = $('.main-voices-edit').data('update-url');

        // Serialize repeater form data
        let formData = $('#main-voices-form').find('input, select').serialize();

        $.ajax({
            url: apiUrl,
            headers: { "X-CSRFToken": csrftoken },
            type: 'POST',
            data: formData + '&ensemble_slug=' + ensembleSlug,
            success: function(response) {
                $('#editMainVoicesModal').modal('hide');
                let html = '';
                if (response.main_voices && response.main_voices.length > 0) {
                    response.main_voices.forEach(function(v){
                        html += '<span class="badge bg-primary me-1">' + v.name + '</span>';
                    });
                } else {
                    html = `<span class="text-muted">${t('notSet')}</span>`;
                }
                $('#main-voices-display').html(html);
            },
            error: function(xhr) {
                let msg = t('saveVoicesError');
                try {
                    const data = JSON.parse(xhr.responseText);
                    if (data.message) msg = data.message;
                    if (data.errors) {
                        // Remove previous error markers
                        $('#song-voices .song-voice-item .error').remove();
                        Object.keys(data.errors).forEach(function(i){
                            const errorsForItem = data.errors[i];
                            const $item = $('#song-voices .song-voice-item').not('.template').eq(i);
                            errorsForItem.forEach(function(err){
                                $('<span class="error mt-2 text-danger"/>').text(err).appendTo($item.find('.center'));
                            });
                        });
                        msg += `\n${t('checkSelectedVoices')}`;
                    }
                } catch(e) {}
                // alert(msg);
            }
        });
    });

});
